/*******************************************************
 * ROUTES SERVICE
 *******************************************************/

"use strict";


/**
 * Module SERVICES
 */
angular.module("services")

	.factory("HlpService", ["$http", "ENV", function ($http, ENV) {

		return {
			getHlpTypes: getHlpTypes,
			getHlp: getHlp
		};


		/**
         * Retourne tous les types de HLP possibles.
         * @param pattern
         * @returns {*}
         */
		function getHlpTypes(useCache) {
			return $http.get(ENV.API_URL + "/configuration/hlp-types",
				{
					cache: useCache ? useCache : false
				});
		}

		/**
         * Récupérer les infos d'un HLP depuis l'API
         * @param hlpId
         */
		function getHlp(hlpId, useCache) {
			return $http.get(ENV.API_URL + "/hlp/" + hlpId,
				{
					cache: useCache ? useCache : false
				});
		}

	}]);


